import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getAgentTools } from '@api';

export const getCoreAgentToolsSlice = createGetAsyncSlice({
	name: 'coreAgentTools',
	receive: true,
	request: true,
	requestHandler: getAgentTools,
	retainDataOnRequest: false
});
